import React from 'react';
import { Row, Col } from 'react-bootstrap';

export default class PropertyPickerArray extends React.Component {

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        const v = parseInt(e.target.value);
        if(v > 255){
            return;
        }
        const i = e.target.name;
        const vHex = Number.isNaN(v) ? '00' : v.toString(16).toUpperCase();
        const vHex2Digits = vHex.length === 1 ? '0' + vHex : vHex;
        const value = this.props.property.value.substring(0, i * 2) + vHex2Digits + this.props.property.value.substring(i * 2 + 2);
        this.props.handleChange(this.props.property.info.name, value);
    }

    render() {
        const arrayLength = this.props.arrayLength;
        let values = [];
        for (var i = 0; i < arrayLength; i++) {
            values[i] = parseInt(this.props.property.value.substring(i * 2, i * 2 + 2), 16)
        }
        return (
            <div>
                {values.map((value, index) => {
                    return (
                        <div key={index}>
                            <Row style={{ margin: "0.93rem auto 0" }}>
                                <Col style={{ paddingLeft: '0', display: "flex" }} sm={1}>
                                    {index}
                                </Col>

                                <Col sm={5} className={this.props.inputPadding ? this.props.inputPadding : ''} style={{ width: "180px", display: "flex", flexDirection: "column" }}>
                                    <input
                                        disabled={this.props.disabled}
                                        name={index.toString()}
                                        type="number"
                                        min={0}
                                        max={255}
                                        step={1}
                                        value={value}
                                        onChange={this.handleChange}
                                    />
                                </Col>
                            </Row>
                        </div>
                    );
                })}
            </div>
        )
    }
}
